module.exports = __webpack_public_path__ + "img/orgLogo.3bd3fbc5.jpg";